import { scrollToTarget } from "@/lib/motion";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink px-6 pb-8 pt-16 text-paper lg:px-12">
    <div className="grid grid-cols-1 gap-6 border-t border-paper/20 pt-6 text-[13px] sm:grid-cols-2 lg:grid-cols-4">
      <p className="font-medium tracking-[0.04em]">ELDIIAR DZHUMAGAZIEV</p>
      <p className="text-paper/70">Independent Brand &amp; Multidisciplinary Designer</p>
      <p className="text-paper/70">© 2026</p>
      <button
        type="button"
        onClick={() => scrollToTarget(0)}
        data-testid="footer-back-to-top"
        className="group justify-self-start text-left lg:justify-self-end"
      >
        <span className="u-link">Back to top</span> <span className="inline-block transition-transform duration-500 group-hover:-translate-y-1">↑</span>
      </button>
    </div>
  </footer>
);
